const formQueryUrl = (data: Record<string, any>[], sign?: string): string => {
  let query = "";

  data?.map((item) => {
    Object.keys(item).map((itemKey) => {
      const value = item[itemKey];
      if (value) {
        query += `${query === "" && sign ? sign : "&"}${itemKey}=${value}`;
      }
    });
  });

  return query;
};

export default formQueryUrl;
